import { saveAs } from 'file-saver';

export const exportCompanyData = async (companyId: string) => {
  const { data: company } = await supabase
    .from('companies')
    .select('*')
    .eq('id', companyId)
    .single();

  const { data: expenses } = await supabase
    .from('company_expenses')
    .select('*')
    .eq('company_id', companyId);

  const { data: employees } = await supabase
    .from('company_employees')
    .select('*')
    .eq('company_id', companyId);

  const { data: locations } = await supabase
    .from('company_locations')
    .select('*')
    .eq('company_id', companyId);

  const exportData = {
    company,
    expenses,
    employees,
    locations,
    exportDate: new Date().toISOString()
  };

  const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
  saveAs(blob, `company-data-${company.name}-${format(new Date(), 'yyyy-MM-dd')}.json`);
};

export const importCompanyData = async (file: File) => {
  const fileContent = await file.text();
  const data = JSON.parse(fileContent);

  // Validate data structure
  if (!data.company || !data.expenses || !data.employees || !data.locations) {
    throw new Error('Invalid data format');
  }

  // Import data in transaction
  const { error } = await supabase.rpc('import_company_data', {
    data: data
  });

  if (error) throw error;
  return true;
};